<div class='snackbar-content'>
  <span>{{ data?.message }}</span>
  <button mat-icon-button (click)='dismiss()'>
    <mat-icon>close</mat-icon>
  </button>
</div>
